import {
    ApplicationSubmitToDecisionGate,
    StatusContainer,
} from '@servicetitan/financing-utils-shared';
import { ApplicationDetails } from './ApplicationDetails';
import { ExploreMoreOptions, SecondLookFinancingOption } from '../second-look';
import DeclinedIllustration from '../../common/illustrations/unable-to-load.svg';
import {
    useProviderConfig,
    useSecondLookIntegration,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';
import { Alert, Flex, Text } from '@servicetitan/anvil2';

export const Declined = () => {
    const { defaultWorkflowStage, declinedHeadline, declinedMessage } = useProviderConfig();
    const isExternalApplication = defaultWorkflowStage === 'external-application';
    const secondLookIntegration = useSecondLookIntegration();
    const secondLookProviderName = useSecondLookProviderName();

    return (
        <ApplicationSubmitToDecisionGate>
            {secondLookIntegration.isServiceDegraded && (
                <Alert status="warning" title={`Unable to submit to ${secondLookProviderName}`}>
                    <Text>
                        We're currently unable to submit your application to{' '}
                        {secondLookProviderName} due to a temporary service issue on our end. Please
                        try submitting a {secondLookProviderName} application later.
                    </Text>
                </Alert>
            )}
            <StatusContainer
                headline={isExternalApplication ? '' : (declinedHeadline ?? '')}
                message={isExternalApplication ? undefined : declinedMessage}
                image={DeclinedIllustration}
            >
                {/* Same 845px width as Explore More, even when that card is omitted. */}
                <Flex
                    direction="column"
                    gap="4"
                    style={{
                        width: '845px',
                        maxWidth: '100%',
                        alignSelf: 'center',
                        marginTop: 'var(--spacing-6)',
                    }}
                >
                    {isExternalApplication ? null : <ApplicationDetails />}
                    <SecondLookFinancingOption />
                    <ExploreMoreOptions />
                </Flex>
            </StatusContainer>
        </ApplicationSubmitToDecisionGate>
    );
};
